import * as React from 'react';
import { useState, useContext } from 'react';
import { Grid, Fab, Dialog, useTheme, Zoom } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from 'react-i18next';

import StorageCard from './StorageCard';
import { StorageContext } from '../store/storageContext';
import StorageForm from './StorageForm';

const useStyles = makeStyles((theme: Theme) => ({
  fab: {
    position: 'fixed',
    right: 20,
    bottom: 20,
  },
  lastCard: {
    marginBottom: theme.spacing(10),
  },
}));

type Props = {
  storages: StorageType[];
  loading: boolean;
};

const StorageListMobile: React.FC<Props> = ({ storages, loading }: Props) => {
  const classes = useStyles();
  const [adding, setAdding] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();
  const { addStorage, getStorages, addStorageLoading } = useContext(
    StorageContext
  );

  const handleAddSubmit = (data: StorageFormDto) => {
    addStorage(data, () => {
      setAdding(false);
      getStorages(true);
    });
  };

  const handleAddOpen = () => {
    setAdding(true);
  };

  const handleAddClose = () => {
    setAdding(false);
  };

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  return (
    <Grid container spacing={3}>
      {storages.map((s, index) => (
        <Grid
          key={s.id}
          item
          xs={12}
          className={index === storages.length - 1 ? classes.lastCard : ''}
        >
          <StorageCard storage={s} loading={loading} />
        </Grid>
      ))}
      <Zoom in timeout={transitionDuration} unmountOnExit>
        <Fab
          className={classes.fab}
          color="primary"
          aria-label="add"
          onClick={handleAddOpen}
        >
          <AddIcon />
        </Fab>
      </Zoom>
      <Dialog open={adding} onClose={handleAddClose}>
        <StorageForm
          onSubmit={handleAddSubmit}
          buttonText={t('common:add')}
          loading={addStorageLoading}
          cancelButton
          onCancel={handleAddClose}
        />
      </Dialog>
    </Grid>
  );
};

export default StorageListMobile;
